import React from 'react' // eslint-disable-line no-unused-vars
import { DOWNLOAD_BUTTON, LINK_BUTTON } from '../../constants'
import { CircularProgress } from '@material-ui/core'

const DocumentsTableDesktop = ({
    id,
    languageContent,
    isDownloading,
    columnNames,
    columnKeys,
    rows,
    showDownloadPopupModal,
    searchAuditId }) => {

    const tableRows = flattenGroupedRows(rows)

    const getFormattedData = (itemBundle, column, index) => {
        if (!itemBundle) {
          return
        }
    
        if (column.key === DOWNLOAD_BUTTON) {
          return (
            <div className='download-button-wrapper'>
              <button
                className='btn btn-info btn-rounded patient-download-button'
                id={`download-${itemBundle.parent.id}`}
                type='button'
                disabled={itemBundle.disableDownload}
                onClick={() => showDownloadPopupModal(index, itemBundle)}
              >
                {
                  itemBundle.disableDownload
                    ? <div className='loading-text-centered'>
                    <span>{languageContent.download}</span>
                        <span className='loading-progress-centered'><CircularProgress size={20}/></span>
                      </div>
                    : <React.Fragment>{languageContent.download}</React.Fragment>
                }
              </button>
            </div>
          )
        }
    
        if (column.key === LINK_BUTTON) {
          return (
            <div className='download-button-wrapper modal-link-info'>
              <a
                className='btn btn-info btn-rounded patient-download-button'
                href={itemBundle.parent.url}
                id={`link-${itemBundle.parent.id}`}
                target='_blank'
                rel='noopener noreferrer'
                data-tag='track-exit'
                data-analytics-text='Product Documentation'
              >
                {languageContent.download}
              </a>
            </div>
          )
        }
    
        let data = itemBundle.parent[column.key]
        if (column.isArray) {
          data = data.join(', ')
        }
        return data
      }

    return (
        <React.Fragment>
            <div className='table-responsive table-container'>
                <table className='table'>
                    <thead>
                        <tr>
                            {columnNames.map((name, i) => <th key={name} width={columnKeys[i].width}>{name}</th>)}
                        </tr>
                    </thead>
                    <tbody id={`documentTable-${id}`}>
                        {
                            tableRows.map((item, i) =>
                                <React.Fragment key={`row-${i}-${item.parent.id}`}>
                                    <tr id={`${id}-tr-${i}`} style={{ backgroundColor: item.color }}>
                                        {
                                            columnKeys.map((column, j) =>
                                            <td
                                                id={`${id}-tr-${i}-td-${j}`}
                                                key={column.key}
                                                style={{ ...column.style, ...(item.applyGroupedTableStyle && column.groupedTableStyle) }}
                                            >
                                                {getFormattedData(item, column, i)}
                                            </td>)
                                        }
                                    </tr>
                                </React.Fragment>
                            )
                        }
                    </tbody>
                </table>
            </div>
        </React.Fragment>
        
    )
}

/**
 * Flattens row data into a single array.  Data will be either individual documents or groups of documents,
 * which will need to share the same background color
 * @param {Object[]} tableRows row data points
 * @returns a flat array of table rows, each with a set color property
 */
const flattenGroupedRows = (rowData) => {
    let index = 0
    const tableRows = []
    rowData.forEach(row => {
        if (row.groupedDocuments && row.groupedDocuments.length) {
            const color = getRowColor(index)
            row.groupedDocuments.forEach(document => {
                tableRows.push({ color, ...document })
            })
            index++
        } else {
            tableRows.push({color: getRowColor(index), ...row })
            index++
        }
    })
    return tableRows
}

const getRowColor = (index) => index % 2 === 0 ? 'white' : '#f0f0f0'

export default DocumentsTableDesktop


// WEBPACK FOOTER //
// ./src/mi-app/tables/DocumentsTableDesktop.js